<div matDialogTitle class="dialog-header-row">
	<mat-icon class="dialog-title-icon">assessment</mat-icon>
	<span class="dialog-title-text" [title]="data.title">{{ data.title }}</span>
	<button mat-icon-button class="dialog-close-btn" (click)="close()" aria-label="Fechar">
		<mat-icon>close</mat-icon>
	</button>
</div>

<div mat-dialog-content class="dialog-content-padded">
	<form [formGroup]="anacredForm">
		<div class="edit-row">
			<mat-slide-toggle formControlName="chkAnaliseCredito">Checar Análise</mat-slide-toggle>
			<mat-form-field appearance="outline" class="limite-field">
				<mat-label>Limite de Crédito</mat-label>
				<input
					matInput
					type="text"
					formControlName="limiteCredito"
					currencyMask
					[options]="{ prefix: '', align: 'right', thousands: '.', decimal: ',', precision: 2, allowNegative: false }" />
			</mat-form-field>
		</div>

		<div class="stat-bar">
			<div class="stat-item">
				<mat-icon class="stat-icon primary-color">verified_user</mat-icon>
				<div class="stat-content">
					<span class="stat-label">Checar Análise</span>
					<span class="stat-value">{{ anacredForm.get('chkAnaliseCredito')?.value ? 'Sim' : 'Não' }}</span>
				</div>
			</div>
			<div class="stat-item">
				<mat-icon class="stat-icon accent-color">credit_score</mat-icon>
				<div class="stat-content">
					<span class="stat-label">Limite</span>
					<span class="stat-value">{{ anacredForm.get('limiteCredito')?.value ?? 0 | currency:'BRL' }}</span>
				</div>
			</div>
			<div class="stat-item">
				<mat-icon class="stat-icon warn-color">account_balance_wallet</mat-icon>
				<div class="stat-content">
					<span class="stat-label">Saldo</span>
					<span class="stat-value">{{ analiseCredito?.limiteCreditoSaldo ?? 0 | currency:'BRL' }}</span>
				</div>
			</div>
		</div>

		<div class="analysis-grid">
			<mat-card class="analysis-card">
				<mat-card-title>Compras</mat-card-title>
				<mat-card-content>
					<div class="analysis-row">
						<span>Primeira compra</span>
						<strong>{{ analiseCredito?.valorPrimeiraCompra ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row muted">
						<span>Data</span>
						<span>{{ analiseCredito?.datePrimeiraCompra | date:'dd/MM/yyyy' }}</span>
					</div>
					<div class="analysis-row">
						<span>Última compra</span>
						<strong>{{ analiseCredito?.valorUtimaCompra ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row muted">
						<span>Data</span>
						<span>{{ analiseCredito?.dateUltimaCompra | date:'dd/MM/yyyy' }}</span>
					</div>
					<div class="analysis-row">
						<span>Maior compra</span>
						<strong>{{ analiseCredito?.valorMaior ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row muted">
						<span>Data</span>
						<span>{{ analiseCredito?.dateMaior | date:'dd/MM/yyyy' }}</span>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card class="analysis-card">
				<mat-card-title>Financeiro</mat-card-title>
				<mat-card-content>
					<div class="analysis-row">
						<span>Débitos</span>
						<strong>{{ analiseCredito?.valorDebito ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row">
						<span>Débitos em atraso</span>
						<strong>{{ analiseCredito?.debitosEmAtraso ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row">
						<span>Títulos em aberto</span>
						<strong>{{ analiseCredito?.qtdeTitulosAberto ?? 0 }}</strong>
					</div>
					<div class="analysis-row">
						<span>Maior receber</span>
						<strong>{{ analiseCredito?.valorMaiorReceber ?? 0 | currency:'BRL' }}</strong>
					</div>
					<div class="analysis-row muted">
						<span>Data maior receber</span>
						<span>{{ analiseCredito?.dateMaiorReceber | date:'dd/MM/yyyy' }}</span>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</form>
</div>

<mat-dialog-actions align="end">
	<button mat-raised-button color="primary" type="button" (click)="save()">
		<mat-icon>save</mat-icon>
		Salvar
	</button>
	<button mat-raised-button color="warn" type="button" (click)="close()">
		<mat-icon>close</mat-icon>
		Fechar
	</button>
</mat-dialog-actions>
